import React, { ComponentProps, useRef, useEffect } from 'react';

import { useNavPersistedValue } from '../components/Navigation';

import { ScrollPane } from './ScrollPane';

type Props = ComponentProps<typeof ScrollPane> & { storeKey: string };

export function NavPersistedScrollPane(props: Props) {
  let { storeKey, onScroll, ...otherProps } = props;
  let ref = useRef<HTMLDivElement>(null);
  let key = 'scroll-pane:' + storeKey;
  let [initialScroll, setScroll] = useNavPersistedValue(key, 0);
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = initialScroll;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ScrollPane
      outerRef={ref}
      onScroll={(event) => {
        let scrollTop = Object(event.target).scrollTop as number;
        setScroll(scrollTop);
        onScroll?.(event);
      }}
      {...otherProps}
    />
  );
}
